import { SET_JOB, SET_TAB, SET_TAB_DATA, SET_SHEET, RESET_SHEET, CHANGE_TAB_NAME, SET_SHEET_SETTINGS } from './action-types'

export const setJob = (job) => {
  return (dispatch, getState) => {
    dispatch({
      type: SET_JOB,
      payload: job
    })
  }
}
//
// export const setSheetSettings = (settings) => {
//   return (dispatch, getState) => {
//     dispatch({
//       type: SET_SHEET_SETTINGS,
//       payload: settings
//     })
//   }
// }
//
// export const setTab = (sheet, name) => {
//   return (dispatch, getState) => {
//     dispatch({
//       type: SET_TAB,
//       payload: {
//         sheet: sheet,
//         name: name
//       }
//     })
//   }
// }
//
// export const resetSheet = () => {
//   return (dispatch, getState) => {
//     dispatch({
//       type: RESET_SHEET
//     })
//   }
// }
//
// export const setTabData = (sheet, data) => {
//   return (dispatch, getState) => {
//     dispatch({
//       type: SET_TAB_DATA,
//       payload: {
//         sheet: sheet,
//         data: data
//       }
//     })
//   }
// }
//
//
// export const changeTabName = (sheet, arr, index) => {
//   return (dispatch, getState) => {
//     dispatch({
//       type: CHANGE_TAB_NAME,
//       payload: {
//         sheet: sheet,
//         arr: arr,
//         index: index
//       }
//     })
//   }
// }



// WEBPACK FOOTER //
// ./src/core/finance/actions.js